/* global axios */
import ApiClient from './ApiClient';

class ConversationNotesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId, params = {}) {
    return axios.get(`${this.url}/${conversationId}/notes`, { params });
  }

  show(conversationId, noteId) {
    return axios.get(`${this.url}/${conversationId}/notes/${noteId}`);
  }

  create(conversationId, noteData) {
    const { pipeline_id, ...note } = noteData;
    const params = pipeline_id ? { pipeline_id } : {};
    
    return axios.post(`${this.url}/${conversationId}/notes`, {
      note: note,
    }, { params });
  }

  update(conversationId, noteId, noteData) {
    return axios.patch(`${this.url}/${conversationId}/notes/${noteId}`, {
      note: noteData,
    });
  }

  delete(conversationId, noteId) {
    return axios.delete(`${this.url}/${conversationId}/notes/${noteId}`);
  }
}

export default new ConversationNotesAPI();
